import React, { useEffect, useState } from 'react'
import { errorToast } from '../../../Utils/Toast/Toast'
import { Modal } from 'react-bootstrap'
import TableFixedPage from '../../TableFixedPage/TableFixedPage'
import { getBarestHelpListApi, getBarestHelpUserInstalmentApi } from '../../../Api/PanelAdminServices'
import BarestHelpTabel from '../../Tables/BarestHelp/BarestHelpTabel'
import { Skeleton } from 'antd'
import TransactionInfo from './Transactions/TransactionInfo'

const BarestHelpContainer = () =>{
        const [modalState,setModalState]=useState(false)
        const [installmentState,setInstallmentState]=useState()
        const[barestHelpListState,setBarestHelpListState]=useState([])
        useEffect(()=>{
            getFactorListHandler()
        },[])
        const getFactorListHandler=()=>{
            getBarestHelpListApi((res)=>{
                if(res.status===1){
                    setBarestHelpListState(res.debt)
                }else{
                    errorToast(res.message)
                }
            })
        }
        const getTransactionHandler=(record)=>{
            setModalState(true)
            getBarestHelpUserInstalmentApi(record.user_id,(res)=>{
                if(res.status===1){
                    setInstallmentState(res.installment)
                }else{
                    errorToast(res.message)
                }
            })
        }

        
      return (
        <div className="w-100 bg-white d-flex flex-column align-items-center py-3">
            <TableFixedPage title={"لیست دریافتی های کمک برست"} />
          <Modal show={modalState} onHide={()=>setModalState(false)} >
            <Modal.Header>
              <Modal.Title style={{fontSize:'1rem',width:'100%',direction:'rtl'}}>
                تراکنشات کمک برست
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
             {installmentState?<TransactionInfo data={installmentState}/>:<Skeleton/>}
            </Modal.Body>
          </Modal>
          <BarestHelpTabel data={barestHelpListState} modalHandler={getTransactionHandler}/>
        </div>
      )
    }
    

export default BarestHelpContainer